export default "__VITE_ASSET__DDFYaxWs__"